// store/slices/stationOverviewSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { fetchStationDetail } from '@/features/config/hooks/station/fetchStationDetail'
import { RootState } from '@/store/stores'

export interface StationOverviewState {
  data: any | null
  loading: boolean
  error: string | null
}

const initialState: StationOverviewState = {
  data: null,
  loading: false,
  error: null,
}

export const fetchStationOverview = createAsyncThunk(
  'stationOverview/fetchById',
  async ({ interfaceId, stationId }: { interfaceId: any; stationId: any }) => {
    return fetchStationDetail(String(interfaceId), String(stationId))
  }
)

const stationOverviewSlice = createSlice({
  name: 'stationOverview',
  initialState,
  reducers: {
    resetStationOverview(state) {
      state.data = null
      state.error = null
      state.loading = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStationOverview.pending, (state) => {
        state.loading = true
      })
      .addCase(fetchStationOverview.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchStationOverview.rejected, (state) => {
        state.loading = false
      })
  },
})

export const { resetStationOverview } = stationOverviewSlice.actions
export const stationOverviewState = (state: RootState) => state.stationOverview
export default stationOverviewSlice.reducer
